
import React from "react";
import { Modal } from "../components/modal";
import { Action } from "../funcs/utils";

const OK_BUTTON = [
  {
    label: "Ok",
    id: "ok",
  }
];


const InfoDialog = props => {

  const div_style = {
    fontSize: "1.5rem",
  }

  const buttons = props.buttons || OK_BUTTON;

  const mk_button = button => {
    let disabled = false;
    if ('disabled' in button) {
      disabled = button.disabled;
    }
    return (
      <div style={{flex: "1"}} align={"center"} key={button.id}>
        <Action
          onClick={props.onClick(button.id)}
          disabled={disabled}>
          { button.label }
        </Action>
      </div>
    )
  };

  return (
    <Modal
      container_style={{width: "40rem"}}
      show={true}
      onDismiss={props.onClose}
      onClose={props.onClose}
      noFooter={true}>
      <div align={"center"} style={div_style}>
        { props.children }
        <div style={{height: "3rem"}}/>
        <div style={{width: "100%", display: "flex"}}>
          { buttons.map(mk_button) }
        </div>
      </div>
    </Modal>
  )
};

export { InfoDialog };
